'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isClient = typeof window !== 'undefined';
var md5 = require('./md5.min.js');
var jsonp = require('./jsonp');
var debug = require('../../utils/debug');
var log = isClient ? require('@ali/log') : {};

/**
 * 转换短链
 *
 * @param {string} srcUrl 原链接
 * @param {object} config 配置对象
 *
 * @return {string} 短链接，如果转换失败是原链接
 */
module.exports = function doShortenLink(srcUrl, config) {
  var shortLinkService = config.shortLinkService || 'https://buc.kim/dlink';
  var shortLinkPrefix = config.shortLinkPrefix || 'https://buc.kim/d/';
  var start_time = new Date().getTime() / 1000;
  var expire_time = start_time + 365 * 86400;
  var current_time = start_time;
  expire_time = Math.floor(expire_time);
  start_time = Math.floor(start_time);
  current_time = Math.floor(current_time);

  var burl = window.btoa(srcUrl);

  var _signStr = 'src_url=' + burl + '&start_time=' + start_time;
  _signStr += '&current_time=' + current_time + '&lilsivi3svPsd';

  var sign = md5(_signStr);

  var params = {
    src_url: burl,
    start_time: start_time,
    expire_time: expire_time,
    current_time: current_time,
    sign: sign
  };

  return new _promise2.default(function (resolve) {
    var waitTimer = setTimeout(function () {
      debug('[share] doShortenLink: timeout');
      resolve(srcUrl);
    }, 2000);
    jsonp({
      url: shortLinkService,
      data: params,
      callback: function callback(res) {
        // console.log(res);
        clearTimeout(waitTimer);
        if (res.error) {
          // reject(res.error);
          debug('[share] doShortenLink: ' + res.error);
          resolve(srcUrl);
        } else {
          var actname = log.baseParam('actname') || '';
          // 直接返回拼接好的完整 url ，pub 参数是统计字段
          resolve('' + shortLinkPrefix + res.short_link + '?pub=iact-' + actname);
        }
      }
    });
  });
};